// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"04337936daf6a2e45dd7","703":"3e318db45d81f6ea2475","886":"460dea32242ba796f2a6","954":"f1328f4cc5ad083b8866"}[chunkId] + ".js";
};